import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'tc-countdown-new',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class CountdownNewComponent implements OnInit {

    @Input() leftTime: number;
    @Output() finishedEmit = new EventEmitter<boolean>();

    // timer
    timerInterval: any;
    minute: number;
    seconds: number;

    minuteForShow: string;
    secondsForShow: string;
    constructor() {

    }

    ngOnInit(): void {
        this.startTimer();
    }

    private startTimer(): void {
        clearInterval(this.timerInterval);
        this.initialTimer();
        this.timerInterval = setInterval(() => {
            if (this.seconds > 0) {
                --this.seconds;
                this.secondsForShow = this.getStringNumber(this.seconds);

            } else if (this.minute > 0) {
                --this.minute;
                this.seconds = 59;
                this.secondsForShow = '59';
                this.minuteForShow = this.getStringNumber(this.minute);


            } else {
                this.finishedEmit.emit(true);
                clearInterval(this.timerInterval);
            }

        }, 1000);

    }
    private initialTimer(): void {
        if (this.leftTime < 60) {
            this.seconds = this.leftTime;
            this.minute = 0;
            this.secondsForShow = this.getStringNumber(this.seconds);
            this.minuteForShow = '00';
            return;
        }
        if ((this.leftTime % 60) > 0) {
            this.minute = Math.round(this.leftTime / 60);
            this.seconds = this.leftTime % 60;
            this.secondsForShow = this.getStringNumber(this.seconds);

            if (this.seconds > 29) {
                this.minute--;
            }
            this.minuteForShow = this.getStringNumber(this.minute);
            return;
        }
        this.minute = (this.leftTime / 60) - 1;
        if (!isNaN(this.minute)) {
            this.minuteForShow = this.getStringNumber(this.minute);
        } else {
            this.minuteForShow = '00';
        }

        this.seconds = 59;
        this.secondsForShow = '59';

    }

    private getStringNumber(number: number): string {
        if (number < 10) {
            return '0' + number;
        } else {
            return number + '';
        }
    }

}
